import React, { useState } from "react";
import "../styles/FAQ.scss";

const FAQS = [
  {
    q: "¿En cuánto tiempo se ven resultados?",
    a: "Depende del giro y del punto de partida. Normalmente se ven señales desde las primeras semanas, y mejoras más claras conforme optimizamos campañas, mensajes y conversión.",
  },
  {
    q: "¿Ustedes se encargan de todo o yo tengo que hacer algo?",
    a: "Nosotros nos encargamos de la estrategia y la implementación. Tú solo nos compartes la información básica del negocio y aprobaciones rápidas cuando sea necesario.",
  },
  {
    q: "¿Qué incluye el servicio de Contenido + Campañas?",
    a: "Incluye planeación, creación de contenido y campañas publicitarias optimizadas. La idea es trabajar como estrategia completa para atraer prospectos y generar ventas, no solo publicaciones sueltas.",
  },
  {
    q: "¿Necesito tener página web o landing para empezar?",
    a: "No siempre. Podemos iniciar con campañas y después incorporar una landing si es necesario para mejorar la conversión y ordenar el seguimiento.",
  },
  {
    q: "¿Los bots y automatizaciones son obligatorios?",
    a: "No. Se integran cuando realmente aportan valor: atención 24/7, filtrado de prospectos, seguimiento automático o reducción de tareas repetitivas.",
  },
  {
    q: "¿Trabajan con mi giro aunque no sea “famoso” o muy común?",
    a: "Sí. Adaptamos la estrategia a tu tipo de cliente, tu zona y tu oferta. Hemos trabajado con muchos tipos deservicios, construcción, gimnasios y negocios que venden en línea, entre otros. Lo importante es entender a tu cliente ideal y cómo llegarle, más que el giro en sí.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState(null);

  const toggle = (idx) => {
    setOpen((prev) => (prev === idx ? null : idx));
  };

  return (
    <section className="ovit-faq" id="faq">
      <div className="ovit-faq__bg" aria-hidden="true">
        <div className="ovit-faq__grid" />
        <div className="ovit-faq__glow ovit-faq__glow--1" />
        <div className="ovit-faq__glow ovit-faq__glow--2" />
      </div>

      <div className="ovit-faq__container">
        <header className="ovit-faq__header">
          <h2 className="ovit-faq__title">
            Preguntas <span>Frecuentes</span>
          </h2>
          <p className="ovit-faq__subtitle">
            Resolvemos las dudas más comunes antes de que nos contactes.
          </p>
        </header>

        <div className="ovit-faq__list">
          {FAQS.map((item, idx) => {
            const isOpen = open === idx;

            return (
              <div
                key={item.q}
                className={`ovit-faqItem ${isOpen ? "is-open" : ""}`}
              >
                <button
                  type="button"
                  className="ovit-faqItem__q"
                  onClick={() => toggle(idx)}
                  aria-expanded={isOpen}
                >
                  <span>{item.q}</span>
                  <span className="ovit-faqItem__icon" aria-hidden="true">
                    {isOpen ? "−" : "+"}
                  </span>
                </button>

                <div className="ovit-faqItem__aWrap">
                  <div className="ovit-faqItem__a">
                    {item.a}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
